// Add your custom JS here.
( function( $ ) {


    // SMOOOTH SCROLLING
    $('a[href*="#"]').on('click', function(e) {

        // Check if the anchor link is for the current page
        if (this.pathname === window.location.pathname && this.hash) {
            e.preventDefault(); // Prevent default anchor behavior

            var target = $(this.hash);
            if (target.length) {
                // Disable smooth scrolling temporarily
                $('html').css('scroll-behavior', 'auto');

                // Scroll to the target element
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000, function() {
                    // Re-enable smooth scrolling after scrolling is complete
                    $('html').css('scroll-behavior', 'smooth');
                });
            }
        }
    });





















    // // Steps swiper
    // var pageSwiper = new Swiper(".page-swiper", {
    //     slidesPerView: "auto",
    //     spaceBetween: 24,
    //     navigation: {
    //         nextEl: ".page-swiper-next",
    //         prevEl: ".page-swiper-prev",
    //     },
    //     breakpoints: {
    //         // If viewport width is less than 992px
    //         992: {
    //             slidesPerView: 3, // Set slides per view to auto
    //         },
    //     },
    // });









    $(".product-menu-toggle").on("click", function () {
        let targetMenu = $($(this).data("target"));

        if (!$(this).hasClass("active")) {
            $(".product-menu-toggle, .wrapper-product-menu, .backdrop").removeClass("active");

            // If the clicked menu is already open, close everything
            if (targetMenu.hasClass("active")) {
                targetMenu.removeClass("active");
                $(this).removeClass("active");
            } else {
                // Close all other menus
                $(".wrapper-product-menu").removeClass("active").hide();

                // Open the correct menu and activate the clicked button
                targetMenu.addClass("active").show();
                $(this).addClass("active");

                // Activate the backdrop
                $(".backdrop").addClass("active");
            }
        } else {
            $(".product-menu-toggle, .wrapper-product-menu, .backdrop").removeClass("active");
        }
    });


    $(".menu-toggle").on("click", function () {
        $(".backdrop, #wrapper-product-menu, .product-menu-toggle").removeClass("active");
        $("#wrapper-navbar .menu").toggleClass("active");
        $(this).toggleClass("active");
    });


    $(".backdrop").on("click", function () {
        $(this).removeClass("active");
        $(".product-menu-toggle, .wrapper-product-menu").removeClass("active");
    });



    $(".child-category-card").on("click", function () {
        $(this).toggleClass("active");
    });




})(jQuery);
